import Colors from '@components/shared/Colors';
import styled from 'styled-components';

export const ComingSoon = styled.p`
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;

  padding: 5px 8px;
  background: ${Colors.navyBlue};
  border-radius: 2px;
  color: ${Colors.cream};
`;
